import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { withInject } from '@piwikpro/platform';

const CookieInformationRegisterFormRoute = withInject({
  CookieInformationRegisterForm: 'CookieInformationCrate.components.CookieInformationRegisterForm',
})(({ CookieInformationRegisterForm: Form }: any) => <Form />);

export const Route = createFileRoute('/_secured/administration/register-cmp')({
  component: CookieInformationRegisterFormRoute,
});
